import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Button/Button';
import Loading from '../../components/Loading';
import ErrorAlert from '../ErrorAlert/ErrorAlert';
import { ArrowGoBackLineIcon } from '../Icons';

CreationPageContainer.propTypes = {
    title: PropTypes.string.isRequired,
    backButtonText: PropTypes.string.isRequired,
    handleBackButtonClick: PropTypes.func.isRequired,
    errorAlert: PropTypes.shape({
        message: PropTypes.string.isRequired,
        statusCode: PropTypes.number,
    }),
    setErrorAlert: PropTypes.func,
    isLoading: PropTypes.bool,
};

function CreationPageContainer({
    title,
    backButtonText,
    handleBackButtonClick,
    errorAlert = null,
    setErrorAlert,
    isLoading = false,
    children,
}) {
    return (
        <div className="page-position sm:p-6 md:p-8 bg-neutral-50 overflow-y-auto">
            <div className="bg-white w-full min-h-full flex justify-center px-5 sm:px-7 pb-[40px]">
                <div className="w-full max-w-[800px] pt-5">
                    {!isLoading && (
                        <>
                            <div className="mb-5">
                                <Button
                                    type="link"
                                    size="sm"
                                    text={backButtonText}
                                    leadingIcon={ArrowGoBackLineIcon}
                                    onClick={handleBackButtonClick}
                                />
                            </div>
                            <h1 className="font-heading-bold text-heading-bold-m text-neutral-500 mb-8">
                                {title}
                            </h1>
                            {children}
                        </>
                    )}

                    {isLoading && (
                        <div className="h-full flex items-center justify-center">
                            <Loading />
                        </div>
                    )}
                </div>

                <ErrorAlert autoCloseInMS={errorAlert} setErrorAlert={setErrorAlert} />
            </div>
        </div>
    );
}

export default CreationPageContainer;
